import { SendContact } from "../../domain/usecase/send-contact"
import { ContactModel } from "../entity/contact-model"
import { HttpPostClient } from "../http-client/http-post-client"

export class RemoteSendContact implements SendContact {
  private readonly url: string
  private readonly httpPostClient: HttpPostClient<ContactModel, any>

  constructor (url: string, httpPostClient: HttpPostClient<ContactModel, any>) {
    this.url = url
    this.httpPostClient = httpPostClient
  }

  async handle (contactModel: ContactModel): Promise<void> {
    const response = await this.httpPostClient.post({
      url: `${this.url}/contact`,
      data: contactModel
    })
    switch (response.status) {
      case 500:
        break
    }
  }
}